const getFillEmission = () => ({
  jan: "0",
  feb: "0",
  mar: "0",
  apr: "0",
  may: "0",
  jun: "0",
  jul: "0",
  aug: "0",
  sep: "0",
  oct: "0",
  nov: "0",
  dec: "0",
});

export const processEmissionObject = {
  tvoc: {
    active: false,
    fillEmission: getFillEmission(),
  },
  bz: {
    active: false,
    fillEmission: getFillEmission(),
  },
  bd: {
    active: false,
    fillEmission: getFillEmission(),
  },
  vcm: {
    active: false,
    fillEmission: getFillEmission(),
  },
  edc: {
    active: false,
    fillEmission: getFillEmission(),
  },
};
